var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('img',_vm._b({class:['image', { visible: _vm.visible }],attrs:{"src":_vm.src},on:{"load":_vm.onImageLoad}},'img',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }